import {combineReducers} from "redux";
import {loginAlerts} from "./login.reducer";
import {slidesReducer} from "./slides.reducer";
import {searchReducer} from "./search.reducer";
import {deviceAlert} from "./device.reducer";
import {dashboardReducer} from "./dashboard.reducer"
import {sessionStatusReducer} from "./session.reducer";
import {deviceStatusReducer} from "./device_status.reducer";
import {utilsReducer} from "./utils.reducer";
import {previewStatusReducer} from "./preview_status.reducer";
import {adminUrlReducer} from './admin.state.reducer'
import {liveMainCameraPreviewReducer} from './livemaincamerapreview.reducer'
import {liveViewReducer} from './liveview.reducer';
import {viewerSettingReducer} from './viewerSettings.reducer';
import {viewerUrlReducer} from './morpheus.state.reducer';
import {contextMenuReducer} from './context.menu.reducer';
import {casesReducer} from './cases.reducer';
import {searchCaseReducer} from './search.case.reducer';
import {caseStatusReducer} from './case.status.reducer';
import {searchUserReducer} from './search.user.reducer';
import {usersReducer} from './users.reducer';
import {previewTuningReducer} from './preview_tuning.reducer';
import {livemodeReducer} from './livemode.reducer';
import {tileViewerUrlReducer} from './tile.viewer.state.reducer';
import {bloodGridReducer} from "./bloodgrid.reducer";
import {bloodGridRBCReducer} from "./bloodGridRBC.reducer";
import {bloodGridPLTReducer} from './bloodGridPLT.reducer';
import {fieldViewReducer} from "./fieldView.reducer";
import {wbcViewReducer} from "./wbcview.reducer";
import {bloodConfigReducer} from "./bloodConfig.reducer"
import {gammaStateReducer} from "./gamma.state.reducer";
import {mapsStateReducer} from "./maps.state.reducer";
import {screenshotStateReducer} from "./screenshot.state.reducer";
import {triggerReducer} from "./triggers.reducer";
import {deepBioReducer} from "./deepbio.reducer";
import {morpheusSettingReducer} from "./morpheus.setting.reducer";
import {c240LoaderReducer} from './c240_loader.reducer';
import {filesReducer} from "./files.reducer";
import {shareManagerReducer} from "./shareManager.reducer";
import {websiteTourReducer} from "./websitetour.reducer";
import {c240DeviceStatusReducer} from "./c240_device_status.reducer";
import {patientfolderReducer} from "./patientfolder.state.reducer"
import {aclReducer} from "./acl.reducer";
import {slideLoadingReducer} from "./slideLoading.reducer";
import {scanWorkflowReducer} from "./scanWorkflow.reducer";
import {splitSyncSlideReducer} from "./splitSyncSlides.reducer";
import {caseReducer} from "./case.reducer";
import {osdViewerConfigReducer} from "./osd.viewer.config.reducer";

export const rootReducer = combineReducers({
	loginAlerts,
	slidesReducer,
	searchReducer,
	c240DeviceStatusReducer,
	deviceAlert,
	dashboardReducer,
	sessionStatusReducer,
	deviceStatusReducer,
	utilsReducer,
	previewStatusReducer,
	liveViewReducer,
	viewerSettingReducer,
	viewerUrlReducer,
	contextMenuReducer,
	casesReducer,
	searchCaseReducer,
  	caseStatusReducer,
	adminUrlReducer,
	liveMainCameraPreviewReducer,
	searchUserReducer,
	usersReducer,
	previewTuningReducer,
	livemodeReducer,
	tileViewerUrlReducer,
	bloodGridReducer,
	bloodGridRBCReducer,
	bloodGridPLTReducer,
	fieldViewReducer,
	wbcViewReducer,
	bloodConfigReducer,
	gammaStateReducer,
	mapsStateReducer,
	screenshotStateReducer,
	triggerReducer,
	deepBioReducer,
	morpheusSettingReducer,
	c240LoaderReducer,
	filesReducer,
	shareManagerReducer,
	websiteTourReducer,
	patientfolderReducer,
	aclReducer,
	slideLoadingReducer,
	scanWorkflowReducer,
	splitSyncSlideReducer,
	caseReducer,
	osdViewerConfigReducer,
});
